export const iconFontAwesomeHumanitarianLandmark = (
	<i className="fa-solid fa-landmark"></i>
);
